module.exports = __webpack_public_path__ + "static/media/solid-right.45a62166.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kendra/images/solid-right.svg
// module id = 1173
// module chunks = 0